import { m } from '@/paraglide/messages.js';

/*
 * A sign-in that failed elsewhere — at a provider, or on an emailed link — comes
 * back with the reason in the URL. Only reasons someone can act on get their own
 * line; the rest read as a generic failure, all we could honestly tell them.
 */
export function refusedSignInMessage(code: string | undefined): string {
  if (!code) {
    return '';
  }
  /* Expired or already used: without saying so, people click the same dead link again. */
  if (code === 'INVALID_TOKEN') {
    return m.login_link_expired();
  }
  /*
   * The link was opened in a browser that did not request it — usually the
   * mail was read on another device. The link still works where it was asked
   * for; here, the code from the same mail is the way in.
   */
  if (code === 'LINK_OTHER_DEVICE') {
    return m.login_link_other_device();
  }
  /*
   * The provider authenticated them fine, but nobody provisioned that address
   * here: the same situation the magic link reports, reached by a different door.
   */
  if (code === 'signup_disabled' || code === 'new_user_signup_disabled') {
    return m.login_unknown_account();
  }
  if (code === 'MICROSOFT_DOMAIN_UNVERIFIED') {
    return m.login_microsoft_unverified();
  }
  /*
   * Only an address Wundo never vouched for, one typed into a chat. One sign-in
   * by link settles it for good, so the message says that.
   */
  if (code === 'account_not_linked') {
    return m.login_provider_not_linked();
  }
  if (code === 'access_denied') {
    return m.login_access_denied();
  }
  return m.login_error_generic();
}
